module.exports = __webpack_public_path__ + "static/media/404_v2.1034b5ec.webp";